"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const ice_to_plain_1 = require("ice-to-plain");
exports.enhancerOptions = {
    serialize: {
        replacer(key, value) {
            const plain = ice_to_plain_1.iceToPlain(value, false);
            if (plain != null && plain[ice_to_plain_1.ICE_TYPE_KEY]) {
                const _a = ice_to_plain_1.ICE_TYPE_KEY, __serializedType__ = plain[_a], data = __rest(plain, [typeof _a === "symbol" ? _a : _a + ""]);
                return {
                    __serializedType__,
                    data,
                };
            }
            return value;
        },
        reviver(key, value) {
            if (value != null && value.__serializedType__) {
                return ice_to_plain_1.iceFromPlain(Object.assign({ [ice_to_plain_1.ICE_TYPE_KEY]: value.__serializedType__ }, value.data), false);
            }
            return value;
        },
    },
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ice-redux-devtools/lib/index.js
// module id = 748
// module chunks = 0